import { List } from '@mantine/core';

export const hints = {
    totalUnits: (
        <div>
            <div className="font-bold">Total Units</div>
            <div>
                A <span className="font-bold">Unit</span> is the billing unit
                used in your subscription.
            </div>
            <div>
                Your plan includes a set number of Units, with extra charges if
                you go over.
            </div>
            <div className="font-bold">1 Unit =</div>
            <List size="xs">
                <List.Item>
                    1 standard phone session (up to 3 mins total, with less than
                    5 mins between calls)
                </List.Item>
                <List.Item>
                    2 standard chat sessions (up to 20 messages each, with no
                    more than 5 mins between messages)
                </List.Item>
            </List>
            <div>Definitions may vary by region, industry, or plan.</div>
        </div>
    ),
    totalSessions: (
        <div>
            <div className="font-bold">Total Session Count</div>A number of
            phone and text sessions of all types, excluding test sessions
        </div>
    ),
    totalSecuredRevenue: (
        <div>
            <div className="font-bold">Total Secured Revenue</div>
            The amount of money a business could potentially receive if all
            leads processed by your Newo AI Employee were converted into sales.
            In a simplified calculation, this figure is determined by
            multiplying the number of Total Secured Leads over a given period by
            the Average Lead Value. For certain industries, such as the
            restaurant industry, this figure is calculated more accurately based
            on the number of guests per order and the average bill amount per
            person. You can configure these parameters in the Attributes section
            of your portal.
        </div>
    ),
    totalLeadCount: (
        <div>
            <div className="font-bold">Total Lead Count</div>
            The portion of Sessions in which the client expressed interest to
            book or buy
        </div>
    ),
    totalLeadValue: (
        <div>
            <div className="font-bold">Total Lead Value</div>
            &lt;Total Lead Value&gt; = &lt;Total Lead Count&gt; * &lt;Average
            Lead Value&gt;
            <div>or more precisely</div>
            &lt;Total Lead Value&gt; = SUM of &lt;Lead Value&gt; for each Lead
            session
        </div>
    ),

    totalOpportunityCount: (
        <div>
            <div className="font-bold">Total Opportunity Count</div>
            The portion of Leads excluding those where there were no available
            slots or the client refused.
        </div>
    ),
    totalOpportunityValue: (
        <div>
            <div className="font-bold">Total Opportunity Value</div>
            &lt;Total Opportunity Value&gt; = &lt;Total Opportunity Count&gt; *
            &lt;Average Lead Value&gt;
            <div>or more precisely</div>
            &lt;Total Opportunity Value&gt; = SUM of &lt;Lead Value&gt; for each
            Opportunity session
        </div>
    ),

    totalAdditionalDealCount: (
        <div>
            <div className="font-bold">Total Additional Deal Count</div>
            <p>
                The portion of Opportunities that you statistically convert into
                Deals only thanks to AI Employee. Without the AI Employee, these
                Deals would have been lost.
            </p>
            &lt;Total Additional Deal Count&gt; = SUM of &lt;Opportunity
            Count&gt; normalized by the &lt;Opportunity to Deal Conversion
            Rate&gt; * &lt;Result Success Factor&gt; * &lt;Additional Deal
            Recognition&gt;
        </div>
    ),

    asr: (
        <div>
            <div className="font-bold">Additional Secured Revenue (ASR)</div>
            <p>
                Additional Secured Revenue (ASR) is statistically calculated
                amount of money your business earns exclusively thanks to the AI
                Employee.
            </p>
            <p>
                Additional Secured Revenue (ASR) is calculated for each
                individual session and then aggregated for the desired period.
            </p>
            &lt;Additional Secured Revenue&gt; = &lt;Lead Value&gt; * &lt;Is
            Opportunity&gt; * &lt;Opportunity to Deal Conversion Rate&gt; *
            &lt;Result Success Factor&gt; * &lt;Additional Deal Recognition&gt;
        </div>
    ),

    step1: (
        <div>
            <div className="font-bold">Step 1</div>
            Some sessions were classified as leads
        </div>
    ),
    step2: (
        <div>
            <div className="font-bold">Step 2</div>
            Some of the leads were classified as opportunities.
        </div>
    ),
    step3: (
        <div>
            <div className="font-bold">Step 3</div>
            <p>
                Some of the opportunities were converted into deals by the
                agent.
            </p>{' '}
            <span className="font-bold">Please note</span> that the deals shown
            in the right-hand column are not all deals — they include only those
            that would not have happened without the agent, which is why they
            are labeled as &quot;Additional Deals.&quot;
        </div>
    )
};
